.iconSelect {
    fill: var(--static-text-standard);
}